<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="数字化IT咨询与运维" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <div class="list"><Divider orientation="left">服务目录和协议</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
        <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
          <h4><Icon type="ios-pricetags" /> <a href="https://www.bluehci.com/蓝心云云服务协议.pdf" target="_Blank">服务协议</a></h4>
        </Col>
      </Row>
      <Row style="padding:20px;" gutter="24" class="list">
        <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
          <h4><Icon type="ios-pricetags" /> <a href="https://www.bluehci.com/蓝心数字化IT咨询与运维服务-等级一.pdf" target="_Blank">蓝心数字化IT咨询与运维服务-等级一</a></h4>
        </Col>
        <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
          <h4><Icon type="ios-pricetags" /> <a href="https://www.bluehci.com/蓝心数字化IT咨询与运维服务-等级二.pdf" target="_Blank">蓝心数字化IT咨询与运维服务-等级二</a></h4>
        </Col>
      </Row>
      <div class="list"><Divider orientation="left">经典方案</Divider></div>
      <Row style="padding:20px;" gutter="24" class="list">
        <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5"><router-link to="BlueSolution-CT01">传统企业数字化-经典部署方案</router-link></Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">金蝶系列-经典部署方案</Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">用友系列-经典部署方案</Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5"><router-link to="BlueSolution-U9">用友U9系列-经典部署方案</router-link></Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">轻量数据型行业系统部署方案</Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">中量数据型行业系统部署方案</Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="10" :lg="6" :xl="6" :xxl="6">
            <Card class="blueiaas-card">
              <Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
                <Paragraph>
                  <Text style="padding: 3px 6px 3px 6px; background-color:rgb(252, 186, 2); color:#333;">新品</Text>
                </Paragraph>
                <Title :level="5">大量数据型行业系统部署方案</Title>
                <Paragraph>
                  <Text>高度集成，一体交付，售价 【面议】</Text>
                </Paragraph>
                <Paragraph>
                  <ul>
                      <li>最小单节点即可交付</li>
                      <li>
                          可选集群，高可用，独立的数据冷备等多方面的能力
                      </li>
                  </ul>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
      </Row>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
export default {
  name: 'Blueiaas',
  components: {
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
      BreadcrumbList: [
        {
            title: '首页',
            to: '/'
        },
        {
            title: '数字化IT咨询与运维',
        }
      ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 100%;
}
.blueiaas-card{
  background-color:#f2f2f2;
  margin-top: 20px;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
  .blueiaas-card{
    background-color:#f2f2f2;
    margin-top: 20px;
  }
}
</style>
